// Permission domains the backend recognises, with friendly labels.
export const PERMISSION_DOMAINS = [
  { key: 'userData', label: 'User Data' },
  { key: 'notif', label: 'Notifications' },
  { key: 'ad', label: 'Advertisements' },
  { key: 'challenge', label: 'Challenges' },
  { key: 'group', label: 'Group Management' }
]

// Levels in ascending order. '' means no access for that domain.
export const PERMISSION_LEVELS = ['viewer', 'editor', 'publisher']

export const initialLevels = PERMISSION_DOMAINS.reduce((acc, d) => ({ ...acc, [d.key]: '' }), {})

// Turn the per-domain chosen level into the flag object the membership stores,
// setting every level up to and including the chosen one (e.g. editor implies
// viewer). This matches how the backend route handlers OR the levels together.
export const buildPermissions = (levels) => {
  const permissions = {}
  for (const domain of PERMISSION_DOMAINS) {
    const chosen = levels[domain.key]
    const cutoff = PERMISSION_LEVELS.indexOf(chosen)
    if (cutoff === -1) continue
    for (let i = 0; i <= cutoff; i++) {
      permissions[`${domain.key}_${PERMISSION_LEVELS[i]}`] = true
    }
  }
  return permissions
}
